import { Component, Vue, Ref } from "vue-property-decorator";
import InnerBody from './components/InnerBody'
import InnerBodys from './components/InnerBodys'
import CreatModal from './components/CreatModal.vue'
import { StockShiftOrderServiceProxy,StockShiftOrderMaterialServiceProxy, StockInTypeServiceProxy, StockOutTypeServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
import { EmployeeSearchDTO, EmployeeServiceProxy } from '@/service-proxies/app-v2/employee.service-proxies'
import { AuthorityDomainServiceProxy } from '@/service-proxies/app-v2/system.service-proxies';
import CodeModel from '@/components/CodeModel/index.vue'

const esp = new EmployeeServiceProxy()
const ssodsp = new StockShiftOrderServiceProxy()
const ssomsp = new StockShiftOrderMaterialServiceProxy()
const adsp = new AuthorityDomainServiceProxy()
const sotsp = new StockOutTypeServiceProxy()
const skitsp = new StockInTypeServiceProxy()
@Component({
  components: {
    InnerBody,
    InnerBodys,
    CreatModal,
    CodeModel
  }
})
export default class Alarm extends Vue {
  dataShiftOrder = []
  ShiftMaterialList = []
  selectedRowKeys = []
  addNewVisible = false
  searchKey = ""
  listWare = []
  paginationOrder = {
    pageSize: 10,
    current: 1,
  }
  total = 0
  orderLoading = false
  orderMaterialLoading = false
  materialId = ""
  employeesList = [] // 员工
  treeList = []
  listAllTree = []
  outTypeList = [] // 出库类型
  stockInList = [] //入库类型
  height = 300
  selectId = ""
  resizeTimer = null
  tableScrollHeight = 300
  printVisible = false
  dataList = []

  mounted() {
    this.$nextTick(() => {
      this.materialId = (this.$route.query.materialId ? this.$route.query.materialId : 0).toString()
      esp.getPageEmployees(1,{statusList: [1]} as EmployeeSearchDTO,"",999999).then(res =>{
        this.employeesList = res.records
      })
      sotsp.getStockOutTypeList().then(res =>{
        this.outTypeList = res
      })
      skitsp.getStockInTypeList().then(res =>{
        this.stockInList = res
      })
      adsp.treeList().then(res =>{
        const arr:any = res.data
        arr.forEach(item => {
          this.treeList.push(this.filterData(item))
        })
      })
      this.getList()
    })
  }

  updated(){
    const div = document.body.clientHeight
    this.tableScrollHeight = (div - 360) /2
    this.height = (div - 350) /2
  }

  filterData(item: any) {
    const arr = {
      title: item.title,
      value: item.id,
      key: item.id,
      children: [],
    }
    this.listAllTree.push(arr)
    if (item.children && item.children.length > 0) {
      item.children.forEach(res =>{
        arr.children.push(this.filterData(res))
      })
    } else {
      delete item.children;
    }
    return arr;
  }

  getList(){
    this.orderLoading = true
    ssodsp.pageStockShiftOrder(this.materialId,this.paginationOrder.current,this.searchKey,this.paginationOrder.pageSize).then(res =>{
      this.dataShiftOrder = res.records
      if(res.records && res.records.length > 0){
        this.onClickRow(res.records[0].id)
      }
      this.total = Number(res.total)
      this.orderLoading = false
    }).catch(() =>{

    })
  }

  reload(){
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.addNewVisible = false
    this.getList()
  }
  
  delete(){
    
  }
  
  onSearch(value) {
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.searchKey = value
    this.getList()
  }
  
  addNew(){
    this.addNewVisible = true
  }

  addClose(){
    this.addNewVisible = false
  }

  onSelectChange(selectedRowKeys) {
    this.selectedRowKeys = selectedRowKeys;
    if(selectedRowKeys.length == 1 ){
      this.onClickRow(selectedRowKeys[0])
    }
  }

  handleTableChange(data) {
    this.paginationOrder = {
      pageSize: data.pageSize,
      current: data.current
    }
    this.getList()
  }

  onClickRow(value){
    this.selectId = value
    this.selectedRowKeys = [value]
    this.orderMaterialLoading = true
    ssomsp.listStockShiftOrderMaterial(value).then(res =>{
      this.ShiftMaterialList = res
      this.orderMaterialLoading = false
    }).catch(()=>{
      this.orderMaterialLoading = false
    })
  }
    
  beforeDestroy(){
    clearTimeout(this.resizeTimer)
  }

  changeY(){
    if(this.resizeTimer){
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(function(){
      const div = document.getElementById('ware-topmodal')
      this.tableScrollHeight = div.clientHeight
      const bodyTableBody: any = document.querySelector('#ware-topmodal .ant-table-body')
      if(bodyTableBody){
        bodyTableBody.style.maxHeight = (this.tableScrollHeight - 88) + 'px'
      }
    },100)
  }

  printing() {
    this.getData()
    this.printVisible = true
  }

  cancel() {
    this.selectedRowKeys = []
    this.printVisible = false
  }
  handlerPrint() {
    this.selectedRowKeys = []
    this.printVisible = false
  }

  getData() {
    this.dataList = []
    this.selectedRowKeys.map(id =>{
      this.dataShiftOrder.map(item => {
        if(id === item.id) {
          this.dataList.push({
            code: item.orderCode,
            name: item.orderName
          })
        }
      })
    })
  }

  render() {
    return (
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'} style="display:flex;justify-content: space-between">
          <div>
            <a-button type="primary" onClick={() => this.addNew()} style="margin-right: 8px;">{ this.$t('page_material_ware_move_creat')}</a-button>
            {/* <a-button type="danger" onClick={() => this.delete()} disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;">{ this.$t('delete') }</a-button> */}
            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_workstation_maintain_inport_model')}</a-button>
            <a-button type="default" disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;">{ this.$t('page_import_export')}</a-button> */}
            <a-button type="default" disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;" onClick={() =>this.printing()}>{this.$t("page_print_code")}</a-button>
          </div>
          <div>
            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_my_document_advanced') }</a-button> */}
            <a-input-search placeholder={this.$t('keyword')} style="width: 200px" enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner" style="height:100%">
          <div id="ware-topmodal" style="width:100%;height: calc(50% - 4px);position: relative;box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);background-color: #fff;overflow:auto">
            <inner-body
              height={this.tableScrollHeight}
              selectId={this.selectId}
              selectedRowKeys={this.selectedRowKeys}
              outTypeList={this.outTypeList}
              stockInList={this.stockInList}
              listAllTree={this.listAllTree}
              employeesList={this.employeesList}
              data={this.dataShiftOrder}
              current={this.paginationOrder.current}
              total={this.total}
              loading={this.orderLoading}
              pageSize={this.paginationOrder.pageSize}
              onOnSelectChange={value => this.onSelectChange(value) }
              onHandleTableChange={value => this.handleTableChange(value) }
              onClickRow={value => this.onClickRow(value) }></inner-body>
          </div>
          <div v-resize={{axis: 'y', cb: this.changeY }}></div>
          <div style="width:100%;height: calc(50% - 4px);position: relative;box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);background-color: #fff;overflow:auto">
            <inner-bodys
              height={this.height}
              data={this.ShiftMaterialList}
              loading={this.orderMaterialLoading}
            ></inner-bodys>
          </div>
        </div>
        {this.addNewVisible ? <creat-modal
          outTypeList={this.outTypeList}
          stockInList={this.stockInList}
          treeList={this.treeList}
          employeesList={this.employeesList}
          visible={this.addNewVisible}
          areaId={this.materialId}
          onClose={() => this.addClose()}
          onReload={() => this.reload()}></creat-modal> : null }
        <code-model
        visible={this.printVisible}
        onCancel={this.cancel}
        dataList={this.dataList}
        onprint={this.handlerPrint}
        >
        </code-model>
      </blank-view>
    )
  }
}
